import React, { useEffect } from "react";
import moment from "moment";
import WineBehindGreenery from "../images/wine-behind-greenery.png";
import WineFlights from "../images/enoteca/wineflight.jpeg";
import Button from "../components/Button";
import Flatbread from "../images/squares/flatbread.webp";
import Cheeseboard from "../images/squares/olives.webp";
import Brownie from "../images/enoteca/Gelato Brownie.jpg";
import Flights from "../images/squares/flights.webp";
import Affogato from "../images/enoteca/Affogato2.jpg";
import Gelato from "../images/enoteca/GelatoX2.jpg";
import Fence from "../images/squares/fence.webp";
import Latte from "../images/squares/latte.webp";
import ThreeWines from "../images/squares/three-wines.webp";
import Wave from "../images/waves/wave-light.svg";
import WhiteBottle from "../images/squares/white-bottle.webp";
import WinesRow from "../images/wines-row.jpg";
import pizza from "../images/enoteca/pizza.jpg";
import piadine from "../images/enoteca/Piadine.jpg";
import tastingplate from "../images/enoteca/GourmetTasting.jpg";

const TheEnoteca = (props) => {
  useEffect(() => {
    // Set the document title
    document.title = "Auburn Road - The Enoteca";

    // Optionally, you can return a cleanup function if needed
    return () => {
      // This will run when the component is unmounted or before the effect runs again
      document.title = "Auburn Road Vineyards";
    };
  }, []);

  useEffect(() => {
    let resScript;
    resScript = document.createElement("script");
    resScript.innerHTML = `!function(t,o,c,k){if(!t.tock){var e=t.tock=function(){e.callMethod?
    e.callMethod.apply(e,arguments):e.queue.push(arguments)};t._tock||(t._tock=e),
    e.push=e,e.loaded=!0,e.version='1.0',e.queue=[];var f=o.createElement(c);f.async=!0,
    f.src=k;var g=o.getElementsByTagName(c)[0];g.parentNode.insertBefore(f,g)}}(
    window,document,'script','https://www.exploretock.com/tock.js');

    tock('init', 'auburnroadvineyards');`;
    resScript.async = true;
    document.head.appendChild(resScript);
    return () => resScript.remove();
  }, []);
  return (
    <>
      <img
        src={WineBehindGreenery}
        className="corner-wine-behind-greenery"
        alt="corner-wine-behind-greenery"
      />
      <div className="container p-t-150 m-b-150">
        <h1 className="huge-text-no-quote">
          Welcome To
          <br />
          <span className="accent-text">The Enoteca</span>
        </h1>
        <h3 className="subheading m-t-20">OUR VINEYARD WINE BAR</h3>
        <p className="inner-container">
          Auburn Road’s warm, sophisticated wine bar and outdoor café in the
          vines. Relax as our knowledgeable, friendly staff serve you eclectic,
          terroir-driven wines that belong on the table with the world’s best. A
          hidden gem, enjoy gourmet wood-fired pizza and live original music by
          global artists.
        </p>
        <Button
          id="enoteca-main-reservation-click"
          type="brush"
          href={`https://www.exploretock.com/auburnroadvineyards/search?date=${moment().format(
            "YYYY-MM-DD"
          )}&size=2`}
          target="_blank"
          rel="noreferrer noopener"
        >
          Make a reservation
        </Button>
        <iframe
          width="800"
          height="450"
          style={{ maxWidth: "100%", margin: "20px 0" }}
          src="https://www.youtube.com/embed/wqIzi8XbSqs"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
      <div className="enoteca-section relax">
        <img src={Wave} className="position-absolute" alt="" />
        <div className="container">
          <h1 className="huge-text-no-quote text-center">
            Relax at the enoteca
          </h1>
        </div>
      </div>
      <div className="d-flex square-wrap inner-container m-auto">
        <img className="square" src={pizza} alt="cheese board" />
        <img className="square" src={tastingplate} alt="three wines" />
        <img className="square" src={piadine} alt="flatbread" />
      </div>
      <div className="container d-flex flex-column flex-md-row p-t-100 justify-content-between align-items-centers">
        <div>
          <img
            className="flight-img w-100"
            src={WineFlights}
            alt="wine flights"
          />
        </div>
        <div className="m-l-40 m-lg-l-0 m-t-30 m-md-t-0">
          <h1 className="huge-text-no-quote">
            ...Or start <br />
            with a flight
          </h1>
          <p className="m-t-30">
            if you want to do a self-guided tasting to see what feels right
            today…
          </p>
          <Button
            id="flights-reservation-click"
            type="secondary"
            href={`https://www.exploretock.com/auburnroadvineyards/search?date=${moment().format(
              "YYYY-MM-DD"
            )}&size=2`}
            target="_blank"
            rel="noreferrer noopener"
          >
            Make a reservation
          </Button>
        </div>
      </div>
      <div className="enoteca-section m-t-150 music">
        <div className="container p-md-t-150">
          <h1 className="huge-text-no-quote text-center">
            stay for some music
          </h1>
          <p className="text-center m-auto">…and hang out by the vineyards</p>
        </div>
      </div>
      <div className="d-flex square-wrap inner-container m-auto p-b-200">
        <img className="square" src={Fence} alt="auburn road fence" />
        <img className="square" src={Flights} alt="wine flights" />
        <img
          className="square"
          src={WhiteBottle}
          alt="white bottle - auburn road wine"
        />
      </div>

      <div className="enoteca-section brighten m-t-50 m-md-t-0">
        <img src={Wave} className="position-absolute" alt="" />
        <div className="container">
          <h1 className="huge-text-no-quote">...and then maybe</h1>
          <p>something to brighten you up...</p>
        </div>
      </div>
      <div className="d-flex square-wrap inner-container m-auto">
        <img className="square" src={Affogato} alt="affogato" />
        <img className="square" src={Gelato} alt="latte" />
        <img className="square" src={Brownie} alt="chocolate bars" />
      </div>
      <div className="inner-container m-auto text-center m-b-200 p-t-100">
        <p className="m-b-0">...and don't forget to</p>
        <h1 className="huge-text-no-quote">
          bring a little auburn road home with you
        </h1>
        <img
          className="w-100 m-t-75 flight-img"
          src={WinesRow}
          alt="wines in a row"
        />
      </div>
    </>
  );
};

export default TheEnoteca;
